// C4 (ADR-005) — treasurer-first label per estimated-fee row state, rendered at the FE render
// boundary from ONE shared per-axis map (a sibling of `moneyMovementLabels` / `sortInboxCopy`).
// There is no TS `FinanceEnumLabels` — that class is backend-C# only; the established FE
// convention is an exhaustive `Record<Enum,string>`. The engineer-facing `FeeRowState` token
// never renders verbatim (`feedback_treasurer_first_copy`).

import type { FeeRowState } from '../generated/enums.gen';

/** Treasurer-first label per fee row state (C4). Exhaustive Record — a new FeeRowState member
 *  without an entry is a compile error. No engineer enum names render.
 *
 *  ONE calm framing across both states: the row is a "Calculated" processor fee (rate × the
 *  period's donations so far), a definite figure — never a two-label "Estimated"/"Final estimate"
 *  distinction. The state still gates the Record button (Active shows it, Passive doesn't); only
 *  the displayed label is unified. */
export const FEE_ROW_STATE_LABELS: Readonly<Record<FeeRowState, string>> = {
  Passive: 'Calculated',
  Active: 'Calculated',
};
